<template>
  <t-page>

    <t-page-report :reportId="22" type="D"  />

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'PolimixProductionKanban',
  data() {
    return {
      path:"dashboard",
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    },

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
}
</script>
<style>
.tabs_dashboard .active {
  background-color: #FFFFFF !important;
}

.tabs_dashboard .nav-link.active:hover {
  color: #3230d4 !important;
}
</style>
